/**
 * CSS class names.
 * @type {Object}
 */
export const CSS_CLASSES = {
	DIVIDER: 'divider',
};
